import { Component } from '@angular/core';
import {AlertController, IonicPage, NavController, Platform} from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {Sector} from "../../models/data.model";

@IonicPage()
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {

  constructor(public alertCtrl: AlertController,
              public data: DataProvider,
              public platform: Platform,
              public navCtrl: NavController) {
  }

  protected getSectorsOffline(): Sector[] {
    let sectors: Sector[] = [];
    this.data.getSites().forEach(site => {
      site.sectors.forEach(sector => {
        if (this.data.isSectorOffline(sector.id)) sectors.push(sector);
      })
    });
    return sectors;
  }

  protected clearStorage() {
    this.alertCtrl.create({
      title: 'Supprimer tous les secteurs',
      message: 'Voulez vous supprimer tous les secteurs Hors-connexion ?',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
        },
        {
          text: 'Supprimer',
          handler: () => {
            this.data.clearAllData();
          }
        }
      ]
    }).present().catch();
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts